import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

/**
 * ユーザー登録とウォレット作成を確認（Cloud Function経由）
 */
export async function ensureUserRegistered(uid) {
  const ensureRegisteredFn = httpsCallable(functions, 'ensureRegistered');
  await ensureRegisteredFn();
}
